export const removePrefix = val => (val.length === 11 && val.charAt(0) === '1' ? val.slice(1) : val);
export const parseAgencyName = val => (val.split(':').length <= 2 ? val.split(':')[0] : val.split(':')[1]);
